import React from "react";
import "../App.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-columns container">
        
        <div>
          <h3>kk-realtors.in</h3>
          <p>Connecting buyers to premium properties with trust and transparency.</p>
        </div>

        <div>
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#whyus">Why Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <p>Email: info@kk-realtors.in </p>
          <p>Phone: +91 8660426964</p>
          <p>Location: 64, Shivasadan, 1st Main Road, Suguma Layout, Near DLF Town, Bengaluru Urban, Karnataka – 560068</p>
        </div>

      </div>

      <p className="footer-bottom">© 2025 kk-realtors.in | All Rights Reserved</p>
    </footer>
  );
}
